<template>
    <transition appear name="fade">
        <div class="fullscreen sub100 intro-para-container" v-if="scene==='intro'">
            <div class="intro-para" :style="{opacity: opacity, transform: transform}">
                <h1>Great things start with a blueprint…</h1>
                <p>We get that change is hard &mdash; and change to leverage data, analytics and AI is even harder. So we’ve brought together the essential ingredients that major organisations need to leap forward. Strategy & adoption, data & technology, great culture, prototyping, staff empowerment and sound policy are the building blocks we assemble to pave the way for meaningful change.</p>
                <div class="instructions--div">
                    <p class="instructions">
                        <span>
                            <ScrollIcon class="scroll icon"/>
                        </span>
                        <strong>Scroll to explore</strong>
                    </p>
                    <p class="instructions">
                        <span>
                            <TouchIcon class="icon touch"/>
                        </span>
                        <strong>Touch for more details</strong>
                    </p>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapState } from 'vuex'
import { tween, transform } from 'popmotion'
const { interpolate } = transform

import { sceneData } from '@/util/sceneMap'
import updateOnScroll from 'uos'

import ScrollIcon from '@/assets/svg/baseline-arrow_downward-24px.svg'
import TouchIcon from '@/assets/svg/baseline-touch_app-24px.svg'

export default {
    components: {
        ScrollIcon,
        TouchIcon
    },
    data() {
        return {
            progress: 0
        }
    },

    computed: {
        ...mapState(['scene', 'h']),

        opacity() {
            if (this.scene !== 'intro') {
                return 0
            } else {
                return this.interpolate(this.progress)
            }
        },

        transform() {
            return null
            if (this.scene !== 'intro') {
                return null
            } else {
                const v = this.transformInterpolate(this.opacity)
                return `translate(0, ${v}px)`
            }
        },

        transformInterpolate() {
            return interpolate([1, 0], [0, -this.h / 6])
        },

        interpolate() {
            return interpolate([0, 0.12, 0.3, 1], [1, 1, 0, 0])
        }
    },

    mounted() {
        let [start, end] = sceneData.intro.scrollProgress
        this.uos = updateOnScroll(start, end, progress => {
            this.progress = progress
        })
    },

    beforeDestroy() {
        // remove update on scorll
        this.uos()
    }
}
</script>

<style lang="stylus" scoped>
.sub80
    top: 100px
    bottom: 100px
    height: calc(100vh - 200px)

.intro-para-container
    display: flex
    align-items: center
    justify-content: center

.intro-para
    max-width: 600px
    padding: 40px

.intro-para h1
    font-family: 'Heebo', Arial, Helvetica, sans-serif
    font-weight: 900
    color: white
    text-transform: uppercase

.intro-para p
    font-family: 'Alegreya', 'Times New Roman', Times, serif
    color: white

.intro-para p strong
    font-family: 700

.fade-enter
    opacity: 0

.fade-enter-active
    transition: opacity 0.6s

.icon
    width: 24px
    height: 24px
    vertical-align: text-bottom
    position: relative
    margin-right: 0.5em
    fill: white

p
    position: relative

.instructions--div
    font-size: 18px
</style>